import * as React from 'react';
import ModalWrapper from '../../../../components/Modal';
import GenericModalContent from '../../../../components/Modal/Content/GenericModalContent';
import { useLanguageElements } from '../../../../language-elements/withLanguageElementsHOC';

interface DeleteFilterModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const DeleteFilterModal: React.FC<DeleteFilterModalProps> = ({ isOpen, onConfirm, onCancel }) => {
    const languageElements = useLanguageElements();

    if (!isOpen) {
        return null;
    }

    return (
        <ModalWrapper isModalOpen={isOpen} hideCloseButton={true} onClose={onCancel}>
            <GenericModalContent
                title=""
                message={languageElements.MODAL_DELETE_FILTER_TEXT}
                onClickPrimaryButton={onConfirm}
                onClickSecondaryButton={onCancel}
                primaryButtonText={languageElements.MODAL_DELETE_BUTTON_TEXT}
                secondaryButtonText={languageElements.MODAL_CANCEL_BUTTON_DEFAULT_TEXT}
            />
        </ModalWrapper>
    );
};

export default DeleteFilterModal;
